import Head from 'next/head';
import { FC } from 'react';

interface Props {
	title?: string;
	description?: string;
	image?: string;
	type?: string;
	url?: string;
}

export const OpenGraphMetadata: FC<Props> = ({ title, description, image, type, url }) => (
	<Head>
		{title ? <meta key="og:title" property="og:title" content={title} /> : null}
		{description ? (
			<meta key="og:description" property="og:description" content={description} />
		) : null}
		{image ? <meta key="og:image" property="og:image" content={image} /> : null}
		{type ? <meta key="og:type" property="og:type" content={type} /> : null}
		{url ? <meta key="og:url" property="og:url" content={url} /> : null}
	</Head>
);
